import {ActivatedRoute, Router} from '@angular/router';
import {Agende} from 'app/model/agende';
import {Component, OnDestroy, OnInit} from '@angular/core';
import * as moment from 'moment';
import {NgbActiveModal, NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {HttpClient, HttpParams} from "@angular/common/http";
import {Config} from "../../config.const";
import {Subscription} from "rxjs";

@Component({
  selector: 'app-appuntamento-specialistico',
  templateUrl: './appuntamento-specialistico.html',
  styleUrls: ['./appuntamento-specialistico.css']
})
export class AppuntamentoSpecialisticoComponent implements OnInit, OnDestroy {

  id: number;
  appuntamento: any;
  appuntamentoSub: Subscription;

  constructor(private route: ActivatedRoute,
              private agende: Agende,
              private router: Router,
              private modalService: NgbModal,
              private $http: HttpClient,
              public activeModal: NgbActiveModal) {
    moment.locale('it');
  }

  ngOnInit(): void {
    this.loadData();
  }

  setId(id: number) {
    this.id = id;
  }

  loadData() {
    const params = new HttpParams().set('id', '' + this.id);

    this.appuntamentoSub = this.$http.get(`${Config.baseURL}/teleconsulto/appuntamento`, {params}).subscribe((response: any) => {
      this.appuntamento = response[0];
    })
  }

  updateData() {

  }

  ngOnDestroy(): void {
    if (this.appuntamentoSub) {
      this.appuntamentoSub.unsubscribe();
    }
  }
}




// WEBPACK FOOTER //
// ./src/app/components/appuntamento-specialistico/appuntamento-specialistico.ts